import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { IconArrowLeft } from "./SVGs";

export const BackButton = (props) => {
  const navigate = useNavigate();
  return (
    <Button
      variant="outline-dark"
      onClick={() => navigate(props.path)}
      className="d-flex align-items-center mb-4"
    >
      <IconArrowLeft />
      <span className="ms-2 d-none d-sm-inline">Back</span>
    </Button>
  );
};
